(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("angular-material"), require("angular-promise-tracker"), require("_"));
	else if(typeof define === 'function' && define.amd)
		define(["angular", "angular-material", "angular-promise-tracker", "_"], factory);
	else if(typeof exports === 'object')
		exports["mdLoading"] = factory(require("angular"), require("angular-material"), require("angular-promise-tracker"), require("_"));
	else
		root["mdLoading"] = factory(root["angular"], root["angular-material"], root["angular-promise-tracker"], root["_"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_6__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition